import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ReactComponent as CustomIcon } from '../../assets/logos/view question.svg';
import { ReactComponent as ViewRemarksIcon } from '../../assets/logos/remarks.svg';
import { ReactComponent as PendingIcon } from '../../assets/logos/pending.svg';
import { ReactComponent as ResubmissionIcon } from '../../assets/logos/resubmission.svg';
import {
  StarFilled,
  ReadFilled,
  ReadOutlined,
  StarOutlined,
  LeftOutlined,
  GlobalOutlined
  // CheckCircleFilled,
} from "@ant-design/icons";
import { Button, Space, message, Modal, Row, Col, Divider, Badge, Spin, Card, Select, Input, InputNumber, Typography, Popover, QRCode } from "antd";
import {
  submitIdeProjectForEvaluation,
  cancelIdeProjectSubmission,
  addOrRemoveIdeProjectPortfolio,
  getStudentSideResource,
  updateLabAssignmetDetails,
  getAiCodeFeedback,
  saveIdeProjectEvaluation,
  servPublishProjectToPublic,
  servUnPublishProjectFromPublic,
  getQueueResult
} from "../../services/ide-apis";
import { global_var } from "../../services/cs-lab-config";
import { trackEvent,  getEvaluationStatusColor, getEvaluationStatusName, formatDateMonth } from "../utils/util-functions";
import ModalComponent from '../labAssignments/assignment-details-modal';
import { ReactComponent as UserIcon } from '../../assets/logos/evaluate user.svg';
import ReactMarkdown from "react-markdown";
import { ReactComponent as AiIcon } from '../../assets/logos/Ai icon.svg';
import { ReactComponent as AiBadge } from '../../assets/logos/AI badge.svg';
import { ReactComponent as AiPoweredIcon } from '../../assets/logos/AI powered icon.svg';
import { ReactComponent as SubmitIcon } from '../../assets/logos/submit icon.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';


const { Meta } = Card;

const IdeHeader = (props) => {
  const navigate = useNavigate();
  const [showInPortFolio, setShowInPortFolio] = useState(props.showInPortFolio);
  const [isOpen, setIsOpen] = useState(false);
  const [submittedForEvaluation, setSubmittedForEvaluation] = useState(props.submittedForEvaluation);
  const [evaluationStatus, setEvaluationStatus] = useState(props.ideProjectDetails? props.ideProjectDetails.evaluationStatus? props.ideProjectDetails.evaluationStatus: undefined: undefined);
  const [selectedProjectResource, setSelectedProjectResource] = useState(null);
  const [activeTab, setActiveTab] = useState("1");
  const [aiFeedbackData, setAiFeedbackData] = useState("");
  const [aiFeedbackModal, setAiFeedbackModal] = useState(false);
  const [aiFeedbackEvaluateModal, setAiFeedbackEvaluateModal] = useState(false);
  const [evaluationLoading, setEvaluationLoading] = useState(false);
  const [aiFeedbackLoading, setAiFeedbackLoading] = useState(false);
  const [showMark, setShowMark] = useState(false);
  const [evaluationStatusToUpdate, setEvaluationStatusToUpdate] = useState("");
  const [inputFeedback, setInputFeedback] = useState('');
  const [inputImprovement, setInputImprovement] = useState('');
  const [inputScoredMark, setInputScoredMark] = useState('');
  const [inputEvaluationFeedback, setInputEvaluationFeedback] = useState('');
  const [inputEvaluationImprovement, setInputEvaluationImprovement] = useState('');
  const [inputEvaluateScoredMark, setInputEvaluateScoredMark] = useState('');
  const [error, setError] = useState('');
  const [changeNavigate, setChangeNavigate] = useState();
  const [isPublic, setIsPublic] = useState(false);

  useEffect(() => {
    if (props.fkResourceId) {
      getStudentSideResource(props.fkResourceId)
        .then((response) => {
          const responseData = JSON.parse(response.data);
          setSelectedProjectResource(responseData);
          if(global_var.role_id === global_var.STUDENT_ROLE_ID){
            setIsOpen(true);
          }
        })
        .catch((error) => {
          console.error("Service call error", error);
        });
    }
  }, [props.fkResourceId]);

  useEffect(() => {
    setShowInPortFolio(props.showInPortFolio);
  }, [props.showInPortFolio]);

  useEffect(() => {
    setSubmittedForEvaluation(props.submittedForEvaluation);
    if(props.ideProjectDetails? props.ideProjectDetails.evaluationStatus: false){
      setEvaluationStatus(props.ideProjectDetails.evaluationStatus);
    }
    if (props.ideProjectDetails ? props.ideProjectDetails.isPublic : false) {
      setIsPublic(true);
    }
  }, [props]);

  useEffect(() => {
    if (props.ideProjectDetails? (props.ideProjectDetails.fkResourceId &&
      props.ideProjectDetails.fkActivityMapping &&
      props.ideProjectDetails.totalMark &&
      props.ideProjectDetails.totalMark > 0) : false
    ) {
      setShowMark(true);
    }
},[props.ideProjectDetails])

useEffect(() => {
  if(changeNavigate){
    navigate(changeNavigate);
  }
}, [changeNavigate, navigate]);

useEffect(() => {
  if (props.ideProjectDetails && props.ideProjectDetails.evaluationRemarks){
    const lastEvaluationRemark = props.ideProjectDetails.evaluationRemarks[props.ideProjectDetails.evaluationRemarks.length - 1];
    setInputEvaluationFeedback(lastEvaluationRemark.evaluationFeedback)
    setInputEvaluationImprovement(lastEvaluationRemark.evaluationImprovement)
    setInputEvaluateScoredMark(props.ideProjectDetails.scoredMark)
  }
}, [props.ideProjectDetails]);


  const handleCancel = () => {
    setIsOpen(false);
  };

  function handleGoBack() {
    function handleNavigation(){
      if(global_var.pathStack?.length > 0){
        setChangeNavigate(global_var.pathStack[global_var.pathStack.length - 1]);
      } else {
        navigate(-1);
      }
    }
    if (props.unsavedChangePresent) {
      Modal.confirm({
        title: "There are unsaved changes in your editor",
        cancelText: "Leave editor",
        okText: "Back to editor",
        onCancel() {
          handleNavigation()
        },
      });
    } else {
      handleNavigation()
    }
    
  }

  function handleCancelProjectSubmission() {
    Modal.confirm({
      title:
        "Are you sure you want to cancel your submission for project " +
        props.ideProjectDetails.name,
      icon: <ReadFilled />,
      content:
        "Your project will no longer be available for evaluation for teacher / trainer",
      onOk: () => {
        trackEvent("ide_header_cancel_evaluation_ok_clicked", {
          ide_project_stack_name: props.ideProjectDetails.projectLanguage,
        });
        setEvaluationLoading(true);
        cancelIdeProjectSubmission(props.ideProjectDetails._id).then(
          (response) => {
            setEvaluationLoading(false);
            response = response.data;
            if (response.statusCode === 200) {
              setSubmittedForEvaluation(false);
              message.success(response.message);
              if (props.fkResourceId) {
                const updateObj = {
                  status: "cancelled",
                  fkActivityMapping: props.ideProjectDetails.fkActivityMapping,
                  fkUserLoginId:props.ideProjectDetails.fkUserLoginId,
                };
                updateLabAssignmetDetails(props.fkResourceId,updateObj).then((response) => {
                  message.success(response.message)
                });
              }
            } else {
              message.error(response.message);
            }
          }
        );
      },
    });
  }

  function handleAddOrRemoveToPortfolio() {
    let modalTitle;
    if (showInPortFolio) {
      modalTitle =
        "Do you want to remove your project - " +
        props.ideProjectDetails.name +
        " from portfolio.";
    } else {
      modalTitle =
        "Do you want to add your project - " +
        props.ideProjectDetails.name +
        " to portfolio.";

      if (props.unsavedChangePresent) {
        message.warning("Please save your changes.");
        return;
      }
    }

    Modal.confirm({
      title: modalTitle,
      icon: showInPortFolio ? <StarFilled /> : <StarOutlined />,
      onOk() {
        trackEvent(
          !showInPortFolio
            ? "ide_header_add_to_portfolio_ok_clicked"
            : "ide_header_remove_from_portfolio_ok_clicked",
          {
            ide_project_stack_name: props.ideProjectDetails.projectLanguage,
          }
        );

        addOrRemoveIdeProjectPortfolio(
          props.ideProjectDetails._id,
          !showInPortFolio
        ).then((response) => {
          response = response.data;
          if (response.statusCode === 200) {
            setShowInPortFolio(!showInPortFolio);

            message.success(
              !showInPortFolio
                ? "Successfully added to portfolio"
                : "Successfully removed from portfolio"
            );
          } else {
            message.error(response.message);
          }
        });
      },
    });
  }

  function saveIdeProjectEvaluationHandler(aiFeedbackResponse) {
    let evaluationRemarksObj = {}
    let scoredMark;
    if (aiFeedbackResponse.feedback){
      evaluationRemarksObj.evaluationFeedback = aiFeedbackResponse.feedback
    } else if (aiFeedbackResponse.error){
      evaluationRemarksObj.evaluationFeedback = aiFeedbackResponse.error
    }
    if (aiFeedbackResponse.improvement){
      evaluationRemarksObj.evaluationImprovement = aiFeedbackResponse.improvement
    }

    if (aiFeedbackResponse.score) {
      if (typeof aiFeedbackResponse.score === 'number') {
        scoredMark = aiFeedbackResponse.score;
      } else if (typeof aiFeedbackResponse.score === 'string') {
        scoredMark = parseInt(aiFeedbackResponse.score.match(/\d+/)[0]);
      }
    }
    const evaluationStatusToUpdate = "Submitted"
    const teacherRemark = ''
    
    saveIdeProjectEvaluation(
      props.ideProjectDetails._id,
      evaluationStatusToUpdate,
      teacherRemark,
      scoredMark,
      evaluationRemarksObj,
    ).then((response) => {
      response = response.data;
      if (response.statusCode === 200) {
        console.log(response.message)
      } else {
        message.error(response.message);
      }
    });
  }

  function handleProjectSubmission() {
    if (props.unsavedChangePresent) {
      message.warning("Please save your changes.");
      return;
    }

    Modal.confirm({
      title:
        "Are you sure you want to submit your project " +
        props.ideProjectDetails.name +
        " for evaluation",
      content:
        "Once evaluated, you will not be able to make changes to the project.",
      icon: <ReadOutlined />,
      onOk: () => {
        trackEvent("ide_header_submit_for_evaluation_ok_clicked", {
          ide_project_stack_name: props.ideProjectDetails.projectLanguage,
        });
        setEvaluationLoading(true);
        submitIdeProjectForEvaluation(props.ideProjectDetails._id).then(
          (response) => {
            setEvaluationLoading(false);
            response = response.data;
            if (response.statusCode === 200) {
              setSubmittedForEvaluation(true);
              message.success(response.message);
              if (props.fkResourceId) {
                const updateObj = {
                  status: "submitted",
                  fkActivityMapping: props.ideProjectDetails.fkActivityMapping,
                  fkUserLoginId:props.ideProjectDetails.fkUserLoginId,
                };
                updateLabAssignmetDetails(props.fkResourceId,updateObj).then((response) => {
                  message.success(response.message)
                });
                setEvaluationStatus('Submitted')
                setSubmittedForEvaluation(true);

                getAiCodeFeedback(props.ideProjectDetails._id).then((response) => {
                  response = response.data;
          
                  if (response.statusCode === 200) {

                    if (response.aiFeedback) {
                      saveIdeProjectEvaluationHandler(response.aiFeedback);
                    } else if (response.queueId) {
                      let count = 10;
                      const intervalId = setInterval(() => {
                        getQueueResult(response.queueId).then(q_response => {
                          q_response = q_response.data;
                          if (q_response.statusCode === 200) {
                            saveIdeProjectEvaluationHandler(q_response.response);
                            clearInterval(intervalId);
                          } else {
                            count -= 1;
                            if (count === 0) {
                              clearInterval(intervalId);
                            }
                          }
                        });
                      }, 2500)
                    }

                  } else {
                    message.error(response.message);
                  }
                });
              }
            } else {
              message.error(response.message);
            }
          }
        );
      },
    });
  }

  function setAIFeedbackData(dataObj) {
    setAiFeedbackData(dataObj);
    if (dataObj.feedback){
      setInputFeedback(dataObj.feedback)
    } else if (dataObj.error){
      setInputFeedback(dataObj.error)
    }
    if (dataObj.improvement){
      setInputImprovement(dataObj.improvement)
    }
    if (dataObj.score){
      setInputScoredMark(parseFloat(dataObj.score))
    }
  }

  function queueHandler(queueId) {
    let count = 10;
    const intervalId = setInterval(() => {
      getQueueResult(queueId).then(q_response => {
        q_response = q_response.data;
        if (q_response.statusCode === 200) {
          setAiFeedbackLoading(false);
          setAIFeedbackData(q_response.response);
          clearInterval(intervalId);
        } else {
          count -= 1;
          if (count === 0) {
            setAiFeedbackLoading(false);
            clearInterval(intervalId);
          }
        }
      });
    }, 2500)
  }

  function handleViewAIFeedbackClicked(modal,openModal) {
    setAiFeedbackData("");
    setEvaluationStatusToUpdate("Evaluated")
    setAiFeedbackLoading(true);

    if(openModal){
      if (modal==='AI'){
        setAiFeedbackModal(true);
        getAiCodeFeedback(props.ideProjectDetails._id).then((response) => {

          response = response.data;
  
          if (response.statusCode === 200) {

            if (response.aiFeedback) {
              setAIFeedbackData(response.aiFeedback);
              setAiFeedbackLoading(false);
            } else if (response.queueId) {
              queueHandler(response.queueId);
            }
          } else {
            message.error(response.message);
          }
        });
      }else{
        if(props.ideProjectDetails.evaluationRemarks){
          setAiFeedbackLoading(false);
          const lastRemark = props.ideProjectDetails.evaluationRemarks[props.ideProjectDetails.evaluationRemarks.length - 1];
          setAiFeedbackData(lastRemark);
          
          if (lastRemark.evaluationFeedback){
            setInputFeedback(lastRemark.evaluationFeedback)
          }
          if (lastRemark.evaluationImprovement){
            setInputImprovement(lastRemark.evaluationImprovement)
          }
          if (props.ideProjectDetails.scoredMark){
            setInputScoredMark(parseFloat(props.ideProjectDetails.scoredMark))
          }
        }else{
          getAiCodeFeedback(props.ideProjectDetails._id).then((response) => {

            response = response.data;
      
            if (response.statusCode === 200) {

              if (response.aiFeedback) {
                setAIFeedbackData(response.aiFeedback);
                setAiFeedbackLoading(false);
              } else if (response.queueId) {
                queueHandler(response.queueId);
              }

            } else {
              message.error(response.message);
            }
          });

        }
        setAiFeedbackEvaluateModal(true);
      }

    }else{
      getAiCodeFeedback(props.ideProjectDetails._id).then((response) => {
        setAiFeedbackLoading(false);
        response = response.data;

        if (response.statusCode === 200) {

          if (response.aiFeedback) {
            setAIFeedbackData(response.aiFeedback);
            setAiFeedbackLoading(false);
          } else if (response.queueId) {
            queueHandler(response.queueId);
          }

        } else {
          message.error(response.message);
        }
      });
    }

    trackEvent("ide_ai_feedback_button_clicked", {
      ide_project_stack_name: props.ideProjectDetails.projectLanguage,
    });
  }

  function handleEvaluateClicked() {
    let evaluationStatusToUpdate;
    let teacherRemark;
    let scoredMark;
    let improvement;
    let feedback;
    Modal.info({
      icon: null,
      width: 600,
      closable: true,
      okText: 'Save',
      content: (
        <>
          <div className="poppins-regular" style={{marginBottom:'10px'}}>
            {props.ideProjectDetails && props.ideProjectDetails.name && (
            <span className="midnight-blue" style={{ display: 'block',fontSize:'18px' }}>
              {props.ideProjectDetails.name}
            </span>
            )}
            {props.ideProjectDetails && props.ideProjectDetails.studentName && (
            <span className="text-midgrey" style={{ display: 'block',fontSize:'14px' }}>
              <UserIcon />
              {props.ideProjectDetails.studentName}
            </span>
            )}
          </div> 
          <span className="poppins-regular" style={{fontSize:'14px'}}>
            Feedback
          </span>
          <Input.TextArea
              placeholder="Please enter the feedback"
              onChange={(e) => (feedback = e.target.value)}
              rows={3}
              defaultValue={inputEvaluationFeedback}
              style={{marginTop:'5px', color:'#404040',borderColor:'#D7BEF7',padding:'10px'}}
            />

          <span className="poppins-regular" style={{fontSize:'14px'}}>
            Improvement
          </span>
          <Input.TextArea
            placeholder="Please enter the improvement"
            onChange={(e) => (improvement = e.target.value)}
            rows={3}
            defaultValue={inputEvaluationImprovement}
            style={{marginTop:'5px', color:'#404040',borderColor:'#D7BEF7',padding:'10px'}}
          />
          <span className="poppins-regular" style={{fontSize:'14px'}}>
            Status 
          </span>
          <Select
           onChange={(selectedValue) => {
            evaluationStatusToUpdate = selectedValue;
            setError(''); // Clear error when a value is selected
          }}
            placeholder="Please select a status"
            className="mb-2"
            style={{ width: "100%", marginTop:'10px',borderColor:'#D7BEF7' }}
            options={[
              { value: "Evaluated", label: "Evaluated" },
              { value: "Ask for resubmission", label: "Ask for resubmission" },
              { value: "Pending evaluation", label: "Pending evaluation" },
            ]}
          />
          {error && <div style={{ color: 'red', marginTop: '5px' }}>{error}</div>}
          {showMark && (
            <div className="mb-2">
              <span>Score: </span>
              <InputNumber
                min={0}
                max={props.ideProjectDetails.totalMark}
                // onChange={handleScoredMarkInputChange}
                onChange={(value) => {
                  scoredMark = value;
                }}
                onKeyDown={(event) => {
                  if (!/[0-9]/.test(event.key) && event.key !== "Backspace") {
                      event.preventDefault(); // Blocks non-numeric input
                  }
                }}
                placeholder="Enter the mark"
                style={{marginRight: '10px',borderColor:'#D7BEF7',marginLeft:'20px',   }}
                defaultValue={inputEvaluateScoredMark}
              />
              <span style={{fontWeight:'500px'}}>/ {props.ideProjectDetails.totalMark}</span>
            </div>
          )}
        </>
      ),
      onOk: () => {
        if (!evaluationStatusToUpdate) {
          setError('Please select a status!');        
        }

        trackEvent("ide_evaluate_project_ok_clicked", {
          ide_project_stack_name: props.ideProjectDetails.projectLanguage,
          ide_evaluation_status: evaluationStatusToUpdate,
        });

        const evaluationRemarksObj = {
          evaluationImprovement: improvement?improvement:inputEvaluationImprovement,
          evaluationFeedback: feedback?feedback:inputEvaluationFeedback
        };

        saveIdeProjectEvaluation(
          props.ideProjectDetails._id,
          evaluationStatusToUpdate,
          teacherRemark,
          scoredMark?scoredMark:inputEvaluateScoredMark,
          evaluationRemarksObj,
        ).then((response) => {
          response = response.data;
          if (response.statusCode === 200) {
            message.success(response.message);
            props.ideProjectDetails.evaluationStatus = evaluationStatusToUpdate
            setInputEvaluationFeedback(evaluationRemarksObj.evaluationFeedback)
            setInputEvaluationImprovement(evaluationRemarksObj.evaluationImprovement)
            setInputEvaluateScoredMark(scoredMark?scoredMark:inputEvaluateScoredMark)
          } else {
            message.error(response.message);
          }
        });
      },
    });
  }

  const handleFeedbackInputChange = (e) => {
    setInputFeedback(e.target.value);
  };
  const handleImprovementInputChange = (e) => {
    setInputImprovement(e.target.value);
  };
  const handleScoredMarkInputChange = (value) => {
    setInputScoredMark(value);
};

  const clearAiFeedbackData = () => {
    setInputFeedback("");
    setInputImprovement("");
    setInputScoredMark("");
  };

  function saveAiFeedbackResponse() {
    const scoredMark = inputScoredMark;
    const evaluationRemarksObj = {
      evaluationImprovement: inputImprovement,
      evaluationFeedback: inputFeedback
    };
    const teacherRemark=''
    saveIdeProjectEvaluation(
      props.ideProjectDetails._id,
      evaluationStatusToUpdate,
      teacherRemark,
      scoredMark,
      evaluationRemarksObj,
    ).then((response) => {
      response = response.data;
      if (response.statusCode === 200) {
        message.success(response.message);
        props.ideProjectDetails.evaluationStatus = evaluationStatusToUpdate;
      } else {
        message.error(response.message);
      }
      setAiFeedbackEvaluateModal(false)
    });
  }

  function handlePublishToPublic() {
    Modal.confirm({
      title: 'Publish Project',
      content: 'Are you sure you want to publish this project to public?',
      okText: 'Yes',
      cancelText: 'No',
      onOk() {
        // Show loading message
        const loadingMessage = message.loading('Publishing project...', 0);
        
        // Call the service to publish the project
        servPublishProjectToPublic(props.ideProjectDetails._id)
          .then((response) => {
            loadingMessage();
            if (response.data && response.data.statusCode === 200) {
              message.success(response.data.message);
              setIsPublic(true);
            } else {
              message.error(response.data.message || 'Failed to publish project');
            }
          })
          .catch((error) => {
            loadingMessage();
            message.error('An error occurred while publishing the project');
            console.error('Publish error:', error);
          });
      }
    });
  }

  function handleUnpublishFromPublic() {
    Modal.confirm({
      title: 'Unpublish Project',
      content: 'Are you sure you want to unpublish this project from public?',
      okText: 'Yes',
      cancelText: 'No',
      onOk() {
        // Show loading message
        const loadingMessage = message.loading('Unpublishing project...', 0);
        
        // Call the service to unpublish the project
        servUnPublishProjectFromPublic(props.ideProjectDetails._id)
          .then((response) => {
            loadingMessage();
            if (response.data && response.data.statusCode === 200) {
              message.success(response.data.message);
              setIsPublic(false);
            } else {
              message.error(response.data.message || 'Failed to unpublish project');
            }
          })
          .catch((error) => {
            loadingMessage();
            message.error('An error occurred while unpublishing the project');
            console.error('Unpublish error:', error);
          });
      }
    });
  }

  return (
    <>
      <Row className="mt-2">
        <Col className="col d-flex align-items-center" justify="space-evenly">
          <Link onClick={handleGoBack} className="mr-2">
          <span style={{ backgroundColor: '#FFFFFF', padding: '5px', borderRadius: '5px', height:'35px', display: 'flex', alignItems: 'center'}}>
            <LeftOutlined  className="h4" style={{ color: '#000000' }} />
          </span>
          </Link>
          <span className="m-1">
            <span className="h4 poppins-bold"> 
              {props.headerName}
              { submittedForEvaluation || evaluationStatus === 'Ask for resubmission' ?(
                <span className="poppins-medium"
                  style={{
                    marginLeft: '5px',
                    color:
                      getEvaluationStatusColor(evaluationStatus),
                      fontSize:'16px'
                  }}
                >
                  {evaluationStatus === 'Ask for resubmission' ? <ResubmissionIcon /> :
                    evaluationStatus === 'Evaluated' ?<FontAwesomeIcon style={{ color: "#2AC14E", marginRight: '5px', marginInline:'5px'}} icon={faCheckCircle} /> :
                    <PendingIcon />}
                    {getEvaluationStatusName(evaluationStatus)}
                </span>
              ):null}

              <Space direction="vertical">
                <Space wrap>
                  {props.readOnlyMode && <Badge status="error" text="View Only" style={{marginLeft:'10px',color:'#E96358'}} />}
                </Space>
              </Space>


            </span>
          </span>
        </Col>
      </Row>

      <Row>
        <Col className="col d-flex align-items-center" justify="space-evenly" style={{marginLeft: '50px'}}>
          <span className="m-1">
            {props.ideProjectDetails &&
              <span className="poppins-regular" style={{ display: 'block',color:'#2E3876',fontSize:'18px', whiteSpace: 'nowrap',overflow: 'hidden', textOverflow: 'ellipsis',maxWidth: '300px'}}>
                {props.ideProjectDetails.name}
                {props.ideProjectDetails.dueDate &&
                <span className="poppins-medium" style={{fontSize:'14px',opacity:'80%', 'margin-inline': '10px' }}>Due on : {formatDateMonth(props.ideProjectDetails.dueDate)}</span>
            }
              </span>
            }

            {props.ideProjectDetails && props.ideProjectDetails.scoredMark  != null  && props.ideProjectDetails.evaluationStatus === 'Evaluated' && 
              <span className="poppins-medium" style={{ display: 'block',fontSize:'16px' }}>{props.ideProjectDetails.scoredMark} Marks</span>
            }
            
            {global_var.role_id !== global_var.STUDENT_ROLE_ID &&
              (props.ideProjectDetails
                ? props.ideProjectDetails.studentName
                : false) && (
                <>
                  <span style={{display: 'block'}}>
                  <UserIcon />
                  {props.ideProjectDetails.studentName}</span>
                  
                </>
            )}
          </span>
        </Col>
        {props.ideProjectDetails &&
          global_var.role_id === global_var.STUDENT_ROLE_ID &&
          !props.hidePortfolio && (
            <Col className="col text-end pb-1" style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
              <Space>
                <Button
                 style={{ backgroundColor:  '#E96358',color:'#fff' }}
                  icon={showInPortFolio ? <StarOutlined /> : <StarFilled />}
                  type={"primary"}
                  onClick={() => {
                    handleAddOrRemoveToPortfolio();
                  }}
                >
                  {showInPortFolio
                    ? "Remove from Portfolio"
                    : "Add to Portfolio"}
                </Button>

                <Button
                  style={{backgroundColor: '#E96358',color:'#fff' }}
                  icon={
                    submittedForEvaluation ? <SubmitIcon /> : <SubmitIcon />
                  }
                  type={ "primary"}
                  onClick={() => {
                    if (
                      props.ideProjectDetails.evaluationStatus === "Evaluated"
                    ) {
                      message.info("This project is evaluated by teacher.");
                      return;
                    }

                    if (submittedForEvaluation) {
                      handleCancelProjectSubmission();
                    } else {
                      handleProjectSubmission();
                    }
                  }}
                  disabled={evaluationLoading || (props.ideProjectDetails && props.ideProjectDetails.daysLeft === "Overdue")}
                  >
                  {submittedForEvaluation
                    ? "Cancel Submission"
                    : "Submit for Evaluation"}
                  {evaluationLoading && <Spin className="ms-2" size="small" />}
                </Button>
              </Space>
            </Col>
          )}
          <Col className="text-end pb-1" style={{ display: 'flex', alignItems: 'flex-end' }}>
          {global_var.role_id !== global_var.STUDENT_ROLE_ID && props.ideProjectDetails && (props.ideProjectDetails.projectLanguage === 'python' || props.ideProjectDetails.projectLanguage === 'html_css') &&
            global_var.user_login_id !== props.ideProjectDetails.fkUserLoginId && (
            <Button
              type="primary"
              onClick={() => handleViewAIFeedbackClicked('AI & Evaluate',true)} 
              style={{backgroundColor:'#E96358'}}
            >
              <div className="d-flex align-items-center">
                <div className="">
                  <AiBadge style={{ marginTop:'-30px' }} />
                </div>
                <div style={{marginBottom:'30px'}}>
                  <AiIcon />
                  <span>View AI Insights & Evaluate </span>  
                </div>
              </div>
                       
            </Button>
          )}

        {(props.ideProjectDetails && props.ideProjectDetails.projectLanguage === 'vc3') && <>
          {isPublic ? 
              <>
               <Popover content={<>
                <a href={ global_var.SCRATCH_ENDPOINT + props.ideProjectDetails._id + '/view' } target="_blank" rel="noopener noreferrer">{ global_var.SCRATCH_ENDPOINT + props.ideProjectDetails._id + '/view' }</a>
                <QRCode value={global_var.SCRATCH_ENDPOINT + props.ideProjectDetails._id + '/view'} />
                </>} title="Published URL" trigger='click'>
                  <Button
                    type="primary"
                    style={{backgroundColor:'#E96358'}}
                    icon={<GlobalOutlined />}
                  />
                </Popover>
                <Button
                    type="primary"
                    className="ms-1"
                    onClick={handleUnpublishFromPublic} 
                    style={{backgroundColor:'#E96358'}}
                    icon={<GlobalOutlined />}
                  >
                <span>Unpublish from public</span>
                </Button>
              </>
            : <Button
              type="primary"
              onClick={handlePublishToPublic} 
              style={{backgroundColor:'#E96358'}}
              icon={<GlobalOutlined />}
            >
              <span>Publish To Public</span>
            </Button>
          }
        </>}
        
            
          {global_var.role_id !== global_var.STUDENT_ROLE_ID && props.ideProjectDetails && (props.ideProjectDetails.projectLanguage === 'python' || props.ideProjectDetails.projectLanguage === 'html_css') && 
            global_var.user_login_id === props.ideProjectDetails.fkUserLoginId &&(
              
            <Button
              type="primary"
              onClick={() => handleViewAIFeedbackClicked("AI",true)}
              className="ms-1"
              style={{backgroundColor:'#E96358'}}
            >
              <AiIcon />
              <span>AI Feedback </span>     
            </Button>
          )}

          {global_var.role_id !== global_var.STUDENT_ROLE_ID && props.ideProjectDetails && (props.ideProjectDetails.projectLanguage !== 'python' && props.ideProjectDetails.projectLanguage !== 'html_css') && 
            global_var.user_login_id !==
              props.ideProjectDetails.fkUserLoginId && (
              <Button
                type="primary"
                onClick={handleEvaluateClicked}
                style={{ backgroundColor:'#E96358',marginLeft: '8px' }}
              >
                Evaluate
              </Button>
          )}

            {props.fkResourceId && (
              <Button
                icon={ <CustomIcon /> }
                type="primary"
                onClick={() => {
                  setIsOpen(true);
                  setActiveTab("1");
                }}
                style={{ marginLeft: '8px',
                 backgroundColor:'#7564C9', borderColor:'#7564C9' 
                }}
              >
                View Question
              </Button>
          )}
          {(props.ideProjectDetails && (props.ideProjectDetails.evaluationStatus === 'Evaluated' || props.ideProjectDetails.evaluationStatus === 'Ask for resubmission') &&
              (props.ideProjectDetails.teacherRemarks || props.ideProjectDetails.evaluationRemarks) &&
              !(props.ideProjectDetails.projectLanguage === 'vc3' && !props.fkResourceId)) && (
                <Button 
                  icon={<ViewRemarksIcon />}
                  type="primary"
                  onClick={() => {
                    setIsOpen(true);
                    setActiveTab("2"); 
                  }}
                  style={{ marginLeft: '8px',
                    backgroundColor:'#7564C9',borderColor:'#7564C9' 
                  }}
                >
                  View Remarks
                </Button>
              )}
        </Col>
      </Row>
      <Divider className="mt-1 mb-1" 
      style={{backgroundColor:"#D7BEF7"}}
      />
      <Modal
          title="AI Feedback"
          open={aiFeedbackModal}
          onCancel={() => setAiFeedbackModal(false)}
          footer={null}
        >
          {aiFeedbackLoading && (
            <div style={{ textAlign: "center" }}>
              <Space>
                <Spin></Spin>
                AI is generating feedback
              </Space>
            </div>
          )}
          {aiFeedbackData && (
            <div style={{ maxHeight: "55vh", overflow: "auto" }}>
              {aiFeedbackData.feedback && (
                <Card title="Feedback" className="mb-1">
                  <ReactMarkdown children={aiFeedbackData.feedback} />
                </Card>
              )}

              {aiFeedbackData.error && (
                <Card title="Error" className="mb-1">
                  <ReactMarkdown children={aiFeedbackData.error} />
                </Card>
              )}

              {aiFeedbackData.improvement && (
                <Card title="Improvement" className="mb-1">
                  <ReactMarkdown children={aiFeedbackData.improvement} />
                </Card>
              )}

              {aiFeedbackData.score && (
                <Card title="Score" className="mb-1">
                  <ReactMarkdown children={`${aiFeedbackData.score}`} />
                </Card>
              )}
            </div>
          )}
        </Modal>
        {isOpen && (
          <ModalComponent
            isOpen={isOpen}
            handleCancel={handleCancel}
            assignmentObj={selectedProjectResource}
            remarksData={props.ideProjectDetails && props.ideProjectDetails.teacherRemarks}
            evaluationRemarks={props.ideProjectDetails && props.ideProjectDetails.evaluationRemarks}
            activeTab={activeTab}
            evaluationStatus = {props.ideProjectDetails && props.ideProjectDetails.evaluationStatus}
          />
        )}

      {/* Modal for View AI insights & Evaluate */}
      <Modal className="poppins-regular"
        title={
          <div className="poppins-regular">
            {props.ideProjectDetails && props.ideProjectDetails.name && (
            <span className="midnight-blue" style={{ display: 'block',fontSize:'18px' }}>
              {props.ideProjectDetails.name}
            </span>
            )}
            {props.ideProjectDetails && props.ideProjectDetails.studentName && (
            <span className="text-midgrey" style={{ display: 'block',fontSize:'14px' }}>
              <UserIcon />
              {props.ideProjectDetails.studentName}
            </span>
            )}
          </div> 
        }
        open={aiFeedbackEvaluateModal}
        onCancel={() => setAiFeedbackEvaluateModal(false)}
        width={'70%'}
        footer={
          <>
            <Button className="poppins-medium" 
              style={{color:'#E96358', borderColor:'#E96358'}}
              onClick={clearAiFeedbackData}
            >
              Clear
            </Button>
            <Button
              onClick={() => handleViewAIFeedbackClicked('AI & Evaluate',false)} 
              className="poppins-medium" 
              style={{color:'#E96358', borderColor:'#E96358'}}
            >
              Restore AI Feedback</Button>
            <Button
              onClick={() => saveAiFeedbackResponse()} 
              className="poppins-medium" 
              style={{backgroundColor:'#E96358', borderColor:'#E96358',color:'#fff'}}
            >
              Save
            </Button>
          </>
        }
      >
        {aiFeedbackLoading && (
          <div style={{ textAlign: "center" }}>
            <Space>
              <Spin></Spin>
              AI is generating feedback
            </Space>
          </div>
        )}
        {aiFeedbackData && (
          <div>
            <Card className="mb-3 AI" style={{backgroundColor:'#FFF9F1', borderRadius:'10px', border:'0'}}>
              <Meta
                avatar={
                  <div style={{ marginTop: '10px' }}>
                    <Badge
                      style={{ color: "#0057ff"}}                     
                    >
                      <AiPoweredIcon />
                    </Badge>
                  </div>
                }
                title={
                  <Typography.Text>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', maxWidth: '100%' }}>
                      <span className="poppins-medium " 
                        style={{
                          display: 'inline-block',
                          maxWidth: 'calc(100%)',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          color:'#7090F5',
                          fontSize:'16px',
                        }}>
                        AI Powered
                      </span>
                    </div>
                  </Typography.Text>
                }
                description={
                  <Typography.Text className="poppins-regular text-midgrey" style={{fontSize:'12px'}}>
                    <p>Discover feedback and areas for improvement generated by artificial intelligence.</p>
                    <p>Tailor them to fit your unique teaching style.</p>
                  </Typography.Text>
                }
              />
            </Card>

            {aiFeedbackData.feedback || aiFeedbackData.evaluationFeedback ? (
              <>
                <span style={{fontSize:'16px'}}>
                  Feedback
                </span>
                <Input.TextArea value={inputFeedback} onChange={handleFeedbackInputChange}
                className="mb-3 poppins-regular AI-card" 
                  style={{fontSize:'12px', color:'#404040',borderColor:'#D7BEF7',padding:'20px'}}
                />
              </>
            ):(null)}

            {aiFeedbackData.error && (
              <>
                <span style={{fontSize:'16px'}}>
                  Error
                </span>
                <Input.TextArea defaultValue={aiFeedbackData.error} 
                 className="mb-3 poppins-regular AI-card" style={{fontSize:'12px', color:'#404040',borderColor:'#D7BEF7',padding:'20px'}}/>
              </>
            )}

            {aiFeedbackData.improvement || aiFeedbackData.evaluationImprovement ? (
              <>
              <span style={{fontSize:'16px'}}>
                Improvements
              </span>
              <Input.TextArea value={inputImprovement} onChange={handleImprovementInputChange}
              className="mb-3 poppins-regular AI-card" style={{fontSize:'12px', color:'#404040',borderColor:'#D7BEF7',padding:'20px'}}/>                
              </>
              
             ):(null)}
             <Select
              onChange={(selectedValue) => setEvaluationStatusToUpdate(selectedValue)}
              placeholder="Please select a status"
              className="mb-2"
              style={{ width: "30%", borderColor:'#D7BEF7' }}
              options={[
                { value: "Evaluated", label: "Evaluated" },
                { value: "Ask for resubmission", label: "Ask for resubmission" },
                { value: "Pending evaluation", label: "Pending evaluation" },
              ]}
              defaultValue={{ value: "Evaluated", label: "Evaluated" }}
            />

            {/* {aiFeedbackData.score || props.ideProjectDetails.scoredMark } */}
            {props.ideProjectDetails.totalMark ? (
              <div style={{display:'block'}}>
                <span>Score:</span>
                <InputNumber value={inputScoredMark} 
                  min={0}
                  max={props.ideProjectDetails.totalMark}
                  style={{marginLeft:'20px', borderColor:'#D7BEF7' }}
                  onChange={handleScoredMarkInputChange}
                  onKeyDown={(event) => {
                    if (!/[0-9]/.test(event.key) && event.key !== "Backspace") {
                        event.preventDefault(); // Blocks non-numeric input
                    }
                  }}
                />

                {showMark ?(
                   " /" + props.ideProjectDetails.totalMark
                ):(
                  <span> /10</span>
                )}
                
              </div>
           ):(null)} 
          </div>
        )}
      </Modal>
    </>
  );
};

export default IdeHeader;
